export const buildTableColumnOrder = (columns) => columns.map((c) => c.accessorKey);
